<template>
<div></div>
</template>


<script setup>
import { useRouter } from 'vue-router'; // Import the useRouter function from vue-router
import { ref, onMounted, watch,computed } from 'vue';
import { useAuthService } from '@/store/Auth'; //  auth.js file

const router = useRouter();
    const handleLogout = async () => {
try {
//   const response = await axiosInstance.post('/logout');
  localStorage.removeItem('token');
  localStorage.removeItem('authService');
  router.push({ name: 'Login' }); // Redirect to the Login page after logout
} catch (error) {

  localStorage.removeItem('token');
  localStorage.removeItem('authService');
  router.push({ name: 'Login' });
}
}
onMounted(()=>{
    handleLogout()
})
</script>